import { FastpassOrderStatus } from '@hooks-api/types/dataModel/fpOrder'
import { PaymentMethodMap } from '@hooks-api/types/dataModel/payment'
import { Box } from '@pets-ui/Box/Box'
import { Skeleton } from '@pets-ui/Skeleton/Skeleton'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { VStack } from '@pets-ui/VStack/VStack'
import * as stylex from '@stylexjs/stylex'
import { useTranslation } from 'react-i18next'
import { useAdminOrders } from '../../hooks/use-admin-orders'
import { hasTransactionGiveaway } from '../../utils/transaction-giveaway'

const styles = stylex.create({
  paymentContainer: {
    padding: '0.5rem 1rem',
    borderColor: colors.grey300,
    borderRadius: '8px',
    borderStyle: 'solid',
    borderWidth: 1,
    gap: 8,
    fontWeight: 600,
    width: '100%',
  },
})

export const AdminOrderStatus = () => {
  const { t } = useTranslation()
  const { destructuredData: orders } = useAdminOrders()
  const paymentMethod = orders?.payment_method?.type
  const isDispatch = orders?.is_giveaway_dispatch
  const isCanceledOrder = orders?.status === FastpassOrderStatus.CANCELED
  const hasGiveaways = hasTransactionGiveaway(orders)
  const paymentMethodInfo = paymentMethod ? PaymentMethodMap[paymentMethod] : ''

  if (!orders) return <Skeleton height={90} />
  return (
    <VStack alignItems="center" justifyContent="center" gap={1} marginTop={2} width="100%">
      <VStack rootStyle={styles.paymentContainer}>
        {`${t('order.paymentMethod')}：${paymentMethodInfo}`}
        {hasGiveaways && !isCanceledOrder && (
          <Box backgroundColor={colors.grey100} color={colors.grey600} textAlign="center" py={1} borderRadius={4}>
            <Text variant="body" align="center">
              {t(`thankyou.isGiveaways.${Number(hasGiveaways)}.isDispatch.${Number(isDispatch)}`)}
            </Text>
          </Box>
        )}
      </VStack>
    </VStack>
  )
}
